import React from 'react';
import { css } from 'emotion';
import styled from '@emotion/styled';
import { SerializedStyles } from '@emotion/serialize';

type FieldCheckboxProps = {
  label: string | JSX.Element;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  checked: boolean;
  cssProp?: SerializedStyles;
};

type FieldCheckboxWithReduxProps = {
  input: Pick<FieldCheckboxProps, 'name' | 'onChange' | 'value'>;
} & Pick<FieldCheckboxProps, 'label' | 'cssProp' | 'checked'>;

function FieldCheckbox({
  label,
  name,
  onChange,
  value,
  checked,
  cssProp,
}: FieldCheckboxProps) {
  return (
    <div
      className={css`
        display: flex;
        justify-content: center;
        ${cssProp}
      `}
    >
      <CheckboxLabel>
        <input
          id={name}
          type="checkbox"
          checked={checked}
          name={name}
          onChange={onChange}
          value={value}
        />
        {label}
      </CheckboxLabel>
    </div>
  );
}

function FieldCheckboxWithRedux({
  input: { name, onChange, value },
  label,
  cssProp,
  checked,
}: FieldCheckboxWithReduxProps) {
  return (
    <FieldCheckbox
      label={label}
      name={name}
      checked={checked}
      onChange={onChange}
      value={value}
      cssProp={cssProp}
    />
  );
}

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 1.4rem;
  color: #292f36;
  & input[type='checkbox'] {
    margin-right: 11px;
    margin-top: 0;
    position: relative;
    width: 16px;
    height: 16px;
    background-color: #fff;
    border: 1px solid #cccdcf;
    border-radius: 4px;
    -webkit-appearance: none;

    &:checked {
      background: #5000b9;
    }

    &::before {
      visibility: hidden;
      content: '';
      position: absolute;
      left: 4px;
      top: 1px;
      width: 6px;
      height: 10px;
      border: solid #fff;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    &:checked::before {
      visibility: visible;
    }

    &:focus {
      outline: 0;
      border: 1px solid #5000b9;
    }
  }
`;

export { FieldCheckboxWithRedux, FieldCheckbox };
